import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import DeckGL from "deck.gl";
import {WebMercatorViewport, FlyToInterpolator} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TextLayer, ScatterplotLayer} from 'deck.gl'
import Map, { Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"
import LocaleOverviewHotspot from "./LocaleOverviewHotspot.jsx"

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Rectangle,
} from "react-google-maps";
import MarkerWithLabel from "react-google-maps/lib/components/addons/MarkerWithLabel"

import {
  Modal,
  Button,
  Card,
  Divider,
  Text,
  Group,
  Stack,
  SimpleGrid,
} from '@mantine/core';

class LocaleOverviewDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      filePathDict: {},
      qaState: 0,
      localeData: null,
      hotspotList: [],
      map: {
        zoom: 0,
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      },
    };
    autoBind(this);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.close();
  }

  btnEditClicked() {
    this.handleClose();
    this.props.parent.editLocale(this.props.root.getCurrentLocale());
  }

  btnCloseClicked() {
    this.handleClose();
  }

  refresh() {
    let localeData = this.props.root.getCurrentLocale();
    this.setState({
      filePathDict: {},
      localeData: localeData,
      qaState: localeData['qa_state'],
    });
    this.state.localeData = localeData;

    let requestObj = {
      epack_id: parseInt(localeData['id']),
    };
    this.props.root.refs.API.request("get_file_path_by_epack_id", requestObj, this.getFilePathArrayOK, this.getFilePathArrayFailed);
    this.props.root.refs.API.request("get_hotspot_by_epack_id", requestObj, this.getHotspotListOK, this.getHotspotListFailed);

    let localeCenter = {lat: parseFloat(localeData.mid_lat), lng: parseFloat(localeData.mid_lon)};
    this.setState({
      viewState: {
        ...this.state.viewState,
        zoom: 15,
        longitude: localeCenter.lng,
        latitude: localeCenter.lat,
        transitionDuration: 0,
        transitionInterpolator: null
      },
      map:{
        ...this.state.map,
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      }
    });
  }

  getHotspotListOK(res) {
    const result = res && res.body && res.body['result'];
    let hotspotList = (result && Array.isArray(result['hotspot_list'])) ? result['hotspot_list'] : [];
    this.setState({ hotspotList: hotspotList });
  }

  getHotspotListFailed(err) {
    console.log("get hotspot list failed");
  }

  getFilePathArrayOK(res) {
    let dict = {};
    let pathArray = Array.isArray(res && res.body && res.body['result']) ? res.body['result'] : [];
    for (let i = 0; i < pathArray.length; i++) {
      let filePath = pathArray[i];
      if (filePath['tn_path'] != "") {
        dict[filePath['id']] = filePath['tn_path'];
      }
      else {
        dict[filePath['id']] = filePath['path'];
      }
    }
    this.setState({ filePathDict: dict })
  }

  getFilePathArrayFailed(err) {
    console.log("get file path array failed");
  }

  qaStateClicked(qaState) {
    this.setState({ qaState: qaState });
    let requestObj = {
      epack_id: this.state.localeData['id'],
      qa_state: qaState,
    };
    this.props.root.refs.API.request("update_qa_state_by_epack_id", requestObj, this.updateQAstateOK, this.updateQAstateFailed);
  }

  updateQAstateOK(res){
    this.props.root.addNotification(Localization.strings.UPDATED, true);
    let localeId = res.body['result']['locale_id'];
    let qaState = res.body['result']['qa_state'];
    let localeData = this.state.localeData;
    localeData['qa_state'] = qaState;
    this.props.parent.updateLocalLocaleDataById(localeId, localeData);
  }

  updateQAstateFailed(err){
    console.log("update qa state failed");
  }

  componentDidMount() {
    // The QA-state 0-3 shortcut used to live on the MUI Dialog root. Mantine
    // Modal portals its content out of this component's wrapper div, so the
    // key event no longer bubbles there — listen at the document instead and
    // only act while this modal is open.
    document.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (event) => {
    if (!this.state.open) return;
    if (this.props.root.isAdminUser()) {
      let key = parseInt(event.key);
      if (key >= 0 && key <= 3) {
        this.qaStateClicked(key);
      }
    }
  }

  genBoxData(){
    var boxData = []
    boxData.push({
      'type': 'Feature',
      'color': parseInt(this.state.localeData.color).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [[
          [parseFloat(this.state.localeData.ul_lon), parseFloat(this.state.localeData.ul_lat)],
          [parseFloat(this.state.localeData.ul_lon), parseFloat(this.state.localeData.br_lat)],
          [parseFloat(this.state.localeData.br_lon), parseFloat(this.state.localeData.br_lat)],
          [parseFloat(this.state.localeData.br_lon), parseFloat(this.state.localeData.ul_lat)],
          [parseFloat(this.state.localeData.ul_lon), parseFloat(this.state.localeData.ul_lat)]
        ]]
      }
    });
    
    var boxLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: boxData,
        lineWidthScale: 4,
        opacity: 0.4,
        filled: true,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        getFillColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          hex = hex + '1f';
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
        },
        pickable: true,
      });

      return boxLayers
  }

  genTextLayer(){
    var textData = []
    var charSet = ''

    // todo: do not show text label when adding new hotspot
    for(var i = 0; i<this.state.hotspotList.length; i++){
      textData.push({
        'color': parseInt(this.state.hotspotList[i].hotspot_detail.color).toString(16),
        //'name': ' ' + this.state.hotspotList[i].hotspot_detail.name + ' ',
        'name': this.state.hotspotList[i].hotspot_detail.name.length >= 15 ?this.state.hotspotList[i].hotspot_detail.name.substring(0, 15)+ '...' :(this.state.hotspotList[i].hotspot_detail.name),
        'coordinates': [parseFloat(this.state.hotspotList[i].hotspot_detail.lon), parseFloat(this.state.hotspotList[i].hotspot_detail.lat)]
      });
      if( this.state.hotspotList[i].hotspot_detail.name.length >= 15){
        charSet = charSet + this.state.hotspotList[i].hotspot_detail.name + '...';
      }else{
        charSet = charSet + this.state.hotspotList[i].hotspot_detail.name;
      }
    }
    var textLayers = new TextLayer({
      id: 'TextLayer',
      data: textData,
      
      /* props from TextLayer class */
      autoHighlight: false,
      background: true,
      backgroundColor: [255, 255, 255, 150], //cannot use alpha channel
      backgroundPadding: [5, 5, 5, 5],
      characterSet: charSet.split(''),
      getAlignmentBaseline: 'top',
      getAngle: 0,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.coordinates,
      getSize: 12,
      getText: d => d.name,
      getTextAnchor: 'middle',
      sizeScale: 1,
      pickable: true,
    });

    return textLayers;
  }

  genCircleLayer(){
    var circleData = []
    for(var i = 0; i<this.state.hotspotList.length; i++){
      circleData.push({
        'color': parseInt(this.state.hotspotList[i].hotspot_detail.color).toString(16),
        'radius': parseInt(this.state.hotspotList[i].hotspot_detail.radius),
        'centroid': [parseFloat(this.state.hotspotList[i].hotspot_detail.lon), parseFloat(this.state.hotspotList[i].hotspot_detail.lat)]
      });
    }
    
    var circleLayers = new ScatterplotLayer({
      id: 'ColumnLayer',
      data: circleData,
      extruded: false,
      // getLineWidth: 20,
      diskResolution: 30,
      elevationScale: 100,
      getElevation: 0.4 * 50,
      getLineWidth: f => {
        var radius = f.radius;
        return Math.ceil(radius/22);
        // return 2;
      },
      getLineColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
      },
      getFillColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        hex = hex + '1f';
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.centroid,
      getRadius: d => d.radius,
      radiusMinPixels: 1,
      stroked: true,
      pickable: true
    });

    return circleLayers;
  }

  render() {
    // Remove this console.log statement
    // console.log("LocaleOverviewDialog render");

    let localeData = this.state.localeData;
    if (localeData != null && this.state.hotspotList != null) {
      let localeCenter = {lat: parseFloat(localeData.mid_lat), lng: parseFloat(localeData.mid_lon)};
      let localeUpperLeft = {lat: parseFloat(localeData.ul_lat), lng: parseFloat(localeData.ul_lon)};
      let localeBottomRight = {lat: parseFloat(localeData.br_lat), lng: parseFloat(localeData.br_lon)};
      let localeColor = "#" + parseInt(localeData.color).toString(16).padStart(6, '0');
      
      const initialViewState = {
        longitude: localeCenter.lng,
        latitude: localeCenter.lat,
        zoom: 15
      };

      // Derive the map style for the current UI language at render time. Doing this via
      // setState()/direct state mutation during render is a React anti-pattern; deriving a
      // local object keeps render pure while still reflecting a language switch immediately.
      const currentLang = Localization.strings.getLanguage();
      const { viewState } = this.state;
      const mboxStyleForLang = Config.MBOX_STYLE(currentLang);
      const map = {
        ...this.state.map,
        lang: currentLang,
        style: (mboxStyleForLang && mboxStyleForLang[this.state.map._style]) || this.state.map.style,
      };
      const boxLayers = this.genBoxData();
      const textLayers = this.genTextLayer();
      const circleLayers = this.genCircleLayer();

      let editLocaleEnabled = (this.props.root.isAdminUser() || (this.props.root.getSameSchoolEdit() && localeData['school_id'] == this.props.root.getMySchoolId()) || this.props.root.getMyUserId() == localeData['user_id']);
      
      // The description used to be chopped here with a "\n" spliced in every 80
      // characters (40 below 1024px) so a long line could not run past the modal.
      // Inside a <Text> that newline collapses to a space, so the workaround was
      // corrupting the text — it split words and URLs apart on screen. Wrapping is
      // now handled in CSS on the <Text> itself (overflowWrap), which breaks only
      // where a break is actually needed and leaves the stored text untouched.
      let paragraph = localeData['description'];

      return (
        <div>
          <Modal
            opened={this.state.open}
            onClose={this.handleClose}
            size="90%"
            centered
            zIndex={2000}
            title={
              <Group justify="space-between" align="flex-start" wrap="nowrap" style={{width:'100%'}}>
                <Text fw={600} size="lg" style={{width:window.screen.width>=1024?"55%":"20%", wordWrap:"break-word", overflowWrap:"anywhere"}}>
                {Localization.strings.OVERVIEW + " - " + localeData['name']}
                </Text>
                <If condition={this.props.root.isAdminUser()}>
                  <Then>
                    <Button.Group>
                    <Button variant={this.state.qaState == 0? "default":"filled"} size="xs" onClick={() => this.qaStateClicked(0)}>Unchecked (0)</Button>
                    <Button variant={this.state.qaState == 1? "default":"filled"} size="xs" onClick={() => this.qaStateClicked(1)}>Checked (1)</Button>
                    <Button variant={this.state.qaState == 2? "default":"filled"} size="xs" onClick={() => this.qaStateClicked(2)}>Minor (2)</Button>
                    <Button variant={this.state.qaState == 3? "default":"filled"} size="xs" onClick={() => this.qaStateClicked(3)}>Major (3)</Button>
                  </Button.Group>
                  </Then>
                </If>
              </Group>
            }
          >
            <Stack gap="md">
                <Text c="dimmed" style={{maxWidth:"95%", wordWrap:"break-word", overflowWrap:"anywhere"}}>
                  {Localization.strings.DESCRIPTION + ": " }
                  {paragraph}
                </Text>
              <SimpleGrid cols={{base:1, sm:2}}>
                <div>
                  <div style={{position:"relative", height:'70vh'}}>
                    <DeckGL
                      initialViewState={initialViewState}
                      // viewState={viewState}
                      controller={true} height={this.state.height}
                      top="50px" position="relative"
                      layers={[boxLayers, circleLayers, textLayers]}
                      // onViewStateChange={(viewState =>{
                      //   this.setState({
                      //     viewState: {
                      //       ...this.state.viewState,
                      //       zoom: viewState.viewState.zoom,
                      //       longitude: viewState.viewState.longitude,
                      //       latitude: viewState.viewState.latitude,
                      //       transitionDuration: 0,
                      //       transitionInterpolator: null
                      //     }
                      //   });
                      // })}
                    >

                        <Map mapStyle={map.style} mapboxAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
                        <Button.Group style={{top:10, left:10, position:"relative"}}>
                          <Button variant={this.state.map._style=="mono"? "default":"filled"} size="xs" onClick={
                            () => {
                              this.setState({
                                map:{
                                  ...this.state.map,
                                  style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                                  _style: "mono"
                                }
                              });
                              this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                              this.state.map._style = "mono";
                            }
                          }>{Localization.strings.MAP_MONO}</Button>
                          <Button variant={this.state.map._style=="satellite"? "default":"filled"} size="xs" onClick={
                            () => {
                              this.setState({
                                map:{
                                  ...this.state.map,
                                  style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                                  _style: "satellite"
                                }
                              });
                              this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                              this.state.map._style = "satellite";
                            }
                          }>{Localization.strings.MAP_SATELLITE}</Button>
                          <Button variant={this.state.map._style=="cartoon"? "default":"filled"} size="xs" onClick={
                            () => {
                              this.setState({
                                map:{
                                  ...this.state.map,
                                  style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                                  _style: "cartoon"
                                }
                              });
                              this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                              this.state.map._style = "cartoon";
                            }
                          }>{Localization.strings.MAP_VECTOR}</Button>
                        </Button.Group>
                    </DeckGL>
                  </div>
                </div>
                <div>
                  <If condition={this.state.hotspotList.length == 0}>
                    <Then>
                    <Divider variant="dashed" my="sm"/>
                      <Card withBorder={false} shadow="none">
                          Click the EDIT button to start creating hotspot.
                      </Card>
                    </Then>
                  </If>
                  {this.state.hotspotList.map( (row, i) => {
                    return (
                      <div key={i}>
                        <LocaleOverviewHotspot root={this.props.root} parent={this} hotspotData={row['hotspot_detail'] }/>
                      </div>
                    );
                  })}
                </div>
              </SimpleGrid>
              <Group justify="flex-end" mt="sm">
                <Button disabled={!editLocaleEnabled} onClick={this.btnEditClicked}
                variant="default"
                >{Localization.strings.EDIT}</Button>
                <Button
                  onClick={this.btnCloseClicked}
                >
                  {Localization.strings.CLOSE}
                </Button>
              </Group>
            </Stack>
          </Modal>
        </div>
      )
    }
    else {
      return (
        <div/>
      )
    }
  }
}

export default LocaleOverviewDialog;